export function rxsecret() {
	const result = [];
	result.web_port = 4444;
	result.base_api = "https://zdbapi.bonanhem.com";
	//result.base_api = "http://localhost:4443";
	result.theme = "default";
	return result;
}
